/**
 * マンダラ評価の項目名・行動目標名の閲覧可否を判定する mixin
 *
 * 本人（isMine）と指導者（isAnyManager）はテンプレートのロック設定に関わらず閲覧できる。
 * 利用側コンポーネントに isMine / isAnyManager / mandalaGoalTemplate があることを前提とする。
 */
export default {
  computed: {
    canShowEntryName() {
      if (!this.mandalaGoalTemplate) return true
      return this.isMine || this.isAnyManager || !this.mandalaGoalTemplate.isLockEntryNames
    },
    canShowActionGoalNames() {
      if (!this.mandalaGoalTemplate) return true
      return this.isMine || this.isAnyManager || !this.mandalaGoalTemplate.isLockActionGoalNames
    },
    canShowBody() {
      return this.canShowEntryName || this.canShowActionGoalNames
    },
  },
}
